import { defineMessages } from 'react-intl'

export const subscriptionUpdateMessages = defineMessages({
  title: {
    id: 'subscriptionUpdate.title',
    description: 'Title for Subscription Management page',
    defaultMessage: 'Checkout',
  },
  totalToPay: {
    id: 'subscriptionUpdate.totalToPay',
    description:
      'Total To Pay label for bottom panel on Subscription Management page',
    defaultMessage: 'Annual Total',
  },
  totalForSubscription: {
    id: 'subscriptionUpdate.totalForSubscription',
    description:
      'Total For Subscription label for bottom panel on Subscription Management page',
    defaultMessage: 'You pay now',
  },
  nextBillingDateLabel: {
    id: 'subscriptionUpdate.nextBillingDateLabel',
    description:
      'Next Billing Date label for right panel on Subscription Management page',
    defaultMessage: 'Next Billing Date',
  },
  checkoutSubmit: {
    id: 'subscriptionUpdate.checkoutSubmit',
    description:
      'Bottom panel submit button label on Subscription Management - Checkout page',
    defaultMessage: 'Proceed',
  },
  successText: {
    id: 'subscriptionUpdate.successText',
    description: 'Text of modal for successful migrate modal',
    defaultMessage:
      '{planName} for <bold>{homeName}</bold> is enrolled and will renew.',
  },
  errorTitle: {
    id: 'subscriptionUpdate.errorTitle',
    description: 'Error title of migrate subscription modal',
    defaultMessage: 'Error Occurred',
  },
  errorText: {
    id: 'subscriptionUpdate.errorText',
    description: 'Error title of migrate subscription modal',
    defaultMessage:
      'The subscription update failed. Please try again using a different method of payment.',
  },
})
